const RACE_OPTIONS = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Other race',
  'Not specified',
  'Chose not to say',
];

export default RACE_OPTIONS;
